import classNames from "classnames";
import style from "./apptopicbanner.module.scss";
import MobileContentRelatedInformation from "../../features/topic/MobileContentRelatedInformation";
import { useState } from "react";
import AnimatedPopup from "../AnimatedComponents/AnimatedPopup";
import PropTypes from "prop-types";

const MoreButton = ({ expandExpertGroupsSideBar, expandUpdatesSideBar, msPath, setShowTopicActionBar }) => {
  const standardButtonStyle = classNames("size-14", style.button);
  const iconMore = classNames("tg-icons-More", "iconSize");
  const [showRelatedInformation, setShowRelatedInformation] = useState(false);

  const toggleRelatedInformation = () => {
    setShowRelatedInformation(!showRelatedInformation);
    setShowTopicActionBar(showRelatedInformation);
  }

  return (
    <>
      <button
        type="button"
        className={`${standardButtonStyle} ${style.moreButton}`}
        aria-label="More Actions"
        onClick={toggleRelatedInformation}
      >
        <i className={iconMore}></i>
      </button>
      <AnimatedPopup show={showRelatedInformation} zIndex="1005">
        <MobileContentRelatedInformation
          expandExpertGroupsSideBar={expandExpertGroupsSideBar}
          expandUpdatesSideBar={expandUpdatesSideBar}
          popupClose={toggleRelatedInformation}
          msPath={msPath}
        ></MobileContentRelatedInformation>
      </AnimatedPopup>
      <div onClick={toggleRelatedInformation} className={showRelatedInformation ? style.greyedOut : ""}></div>
    </>
  );
};

MoreButton.propTypes = {
  expandExpertGroupsSideBar: PropTypes.func.isRequired,
  expandUpdatesSideBar: PropTypes.func.isRequired,
  msPath: PropTypes.string.isRequired,
  setShowTopicActionBar: PropTypes.func.isRequired,
};

export default MoreButton;
